import type { ReactNode } from 'react';

import { Box } from '../Box/Box';

export const Overlay = ({ children, className }: { children: ReactNode; className?: string }) => {
  return (
    <Box
      zIndex="overlay"
      display="flex"
      position="fixed"
      left={0}
      top={0}
      height="full"
      width="full"
      className={className}
    >
      {children}
    </Box>
  );
};
